import { type FC, type PropsWithChildren } from 'react'

import { TakeoverUnifiedBoxBase } from '@/components-page/advertisement/TakeoverUnifiedBoxBase'
import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'
import { useTakeoverDetection } from '@/hooks/useTakeoverDetection'

export const TakeoverUnifiedBox: FC<PropsWithChildren> = ({ children }) => {
  const hasTakeover = useTakeoverDetection(GPT_COMPONENT_ID.TAKEOVER)

  return (
    <TakeoverUnifiedBoxBase hasTakeover={hasTakeover} background="rgba(255, 255, 255, 0.98)">
      {children}
    </TakeoverUnifiedBoxBase>
  )
}
